<!--
 * @Description: 
 * @Version: 1.0
 * @Autor: 胡彩丽 hucaili@qfei.cn
 * @LastEditors: 胡彩丽 hucaili@qfei.cn
-->
<template>
  <div class="system-form-item-fields">
    <fh-select :options="selectOptions" :placeholder="modulesItem?.placeholder || ''" v-model="modulesItem.fieldValue" :multiple="[3, 5].includes(selectFieldType)" :disabled="disabled || modulesItem.businessData == '0' || disabledAll" @change="handleChange" @popup-visible-change="selectVisibleChange" @remove="selectVisibleChange(false)"></fh-select>

    <!-- <jw-select v-if="modulesItem?.setting?.fieldExt" :popup-container="`.system-form-item-${modulesItem?.setting?.id}`" :trigger-props="{ updateAtScroll: true }" v-model="modulesItem.fieldValue" :placeholder="isQuoteField ? quoteFieldPlaceholder : modulesItem?.placeholder || ''" class="system-form-item-fields" :class="isQuoteField ? 'ly-form-item-fields-disabled' : ''" allow-clear allow-search :multiple="[3, 5].includes(selectFieldType)" :disabled="isQuoteField || disabled || modulesItem.businessData == '0' || disabledAll" @change="handleChange" @popup-visible-change="selectVisibleChange" @remove="selectVisibleChange(false)">
      <jw-option v-for="item in selectOptions" :key="item.value" :value="item.value" :disabled="item?.isEnabled === false">{{ item.label }}</jw-option>
    </jw-select>
    <jw-select v-else class="system-form-item-fields"></jw-select> -->
  </div>
</template>

<script setup>
import { ref, inject, computed } from 'vue';
import { tools } from '@/utils/tools';

const emits = defineEmits(['cb', 'selectPopVisibleCb']);
const isQuoteField = inject('fhFormFieldsParams')?.isQuoteField;
// const quoteFieldPlaceholder = inject('fhFormFieldsParams')?.quoteFieldPlaceholder;

const props = defineProps({
  modules: {
    type: Object,
    default: () => {}
  },
  disabledAll: {
    type: Boolean,
    default: false
  },
  disabled: {
    // 币种(基本信息的币种置灰，明细行的币种正常可选择)
    //  商机阶段 (商机)
    type: Boolean,
    default: false
  }
});

const modulesItem = ref(props?.modules);
const selectOptions = computed(() => {
  const defaultOptions = isQuoteField.value ? modulesItem.value?.setting?.business?.fieldExt : modulesItem.value?.setting?.fieldExt;
  return tools.isJSON(defaultOptions) ? JSON.parse(defaultOptions) : defaultOptions;
});

const selectFieldType = computed(() => {
  return isQuoteField.value ? modulesItem.value?.setting?.business?.fieldType : modulesItem.value?.setting?.fieldType;
});

const flowStage = inject('flow-stage')?.isTask;

const handleChange = () => {
  // 流程阶段单字段编辑在关闭select时，抛出数据
  if (!flowStage) {
    emits('cb', modulesItem.value);
  }
};

//select开关 流程阶段单字段编辑时，选择后关闭弹窗
const selectVisibleChange = (event) => {
  //校验必填/显示
  if (!event) {
    emits('selectPopVisibleCb', modulesItem.value);
  }
};
</script>

<style scoped lang="less">
@import './select.less';
</style>
